<template>
    <div class="card">
        <div class="container-fluid mt-1 mb-1">
            <button v-if="this.permissions.priority == 3 && permission.market_leadge_create" type="button" @click="openCitizenModal()" class="btn btn-primary contct-b "><i class="fa fa-plus"></i> নতুন লিজ আবেদন</button>
            <button v-if="this.permissions.priority == 3 && permission.market_leadge_create" type="button" @click="citizenAdd()"  class="btn btn-primary contct-b ml-0 ml-sm-2"><i class="fa fa-plus"></i> সিটিজেন যোগ করুন </button>

            <form class="form-inline contct my-2 my-lg-0 pull-right">
                <select class="form-control mr-sm-2 market_select" v-model="search.ward">
                    <option value="">মার্কেট সিলেক্ট করুন</option>
                    <option v-for=" ward in wards" :key="ward.id" :value="ward.id">{{ ward.name}}{{ ward.ward_name_bng}}</option>
                </select>
                <input v-model="search.account_no" class="form-control mr-sm-2" type="search" placeholder="Name / Account No" aria-label="Name / Account No">
                <button @click.prevent="searchApplication" class="btn btn-success my-2 my-sm-0" >Search</button>
            </form>
        </div>

        <div  class="container-fluid" style="overflow: auto;">
            <table id="my-table" class="table table-striped table_fields">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">হিসাব নাম্বার</th>
                        <th scope="col">মার্কেট</th>
                        <th style="text-align:right" scope="col">মাসিক বিল</th>
                        <th scope="col">স্ট্যাটাস</th>
                        <!-- <th scope="col">Updated by</th> -->
                        <th v-for="(status,key) in statuses" :key="key" scope="col"><small>{{status}}</small><br><small>স্ট্যাটাস</small></th>
                        <th scope="col">একশন</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(application,key) in allApplication.data" :key="key">
                        <td>{{key+1}}</td>
                        <td><span v-if="application.user">{{application.user.name}}</span><br>{{application.account_no}}<br><span v-if="application.user">{{application.user.mobile_number}}</span></td>

                        <td><span v-if="application.market">{{application.market.name}}</span></td>
                        <td style="text-align:right"><span>{{application.price}} /-</span></td>
                        <!-- <td><span v-if="application.updated_by">{{application.updated_by.name}}</span></td> -->
                        <td><span v-if="application.status == 0" style="color:peru">Pending</span><span v-if="application.status == 1" style="color:green">Approved</span> <span v-if="application.status == 2" style="color:red">Remove</span></td>
                        <td v-if="statuses.includes('অ্যাডমিন')==true"><span @click="viewApproveDetails(application,key,3)" :style="application.confirm_3?'color:green':'color:#888'" style="font-size:12px;cursor:pointer;padding: 4.2px 5px; border-radius: 12px;border: 1px solid;"><i class="fa fa-check"></i></span><sub v-if="application.confirm_2"><i class="fa fa-lock"></i></sub></td>
                        <td v-if="statuses.includes('সচিব')==true"><span @click="viewApproveDetails(application,key,2)" :style="application.confirm_2?'color:green':'color:#888'" style="font-size:12px;cursor:pointer;padding: 4.2px 5px; border-radius: 12px;border: 1px solid;"><i class="fa fa-check"></i></span><sub v-if="application.confirm_1"><i class="fa fa-lock"></i></sub></td>
                        <td v-if="statuses.includes('মেয়র')==true"><span @click="viewApproveDetails(application,key,1)" :style="application.confirm_1?'color:green':'color:#888'" style="font-size:12px;cursor:pointer;padding: 4.2px 5px; border-radius: 12px;border: 1px solid;"><i class="fa fa-check"></i></span></td>
                        <td>
                            <i v-if="permission.market_leadge_view" @click="viewDetails(application,key)" style="font-size:22px; vertical-align:middle" class="icon-eye icons actn"> </i>
                            <i v-if="permission.market_leadge_update" @click="editApplication(application,key)" class="icon-note icons actn" style="vertical-align:middle; font-size:17px;"></i>
                        </td>
                    </tr>
                </tbody>
            </table>
            <nav v-if="loading==false" aria-label="Page navigation example">
                <pagination :limit="5" :data="allApplication" @pagination-change-page="getResults"></pagination>
            </nav>

            <!-- <AddContactModal ref="add_contact_modal"></AddContactModal>
            <EditContactModal :list='list' ref="edit_contact_modal"></EditContactModal>
            <ViewContactModal ref="view_contact_modal"></ViewContactModal> -->
            <!-- <Loader v-if="loading"></Loader> -->
        </div>
        <findUser @userInfo='userInfo' ref="find_user" />
        <addModal  @addHolding='addHolding' ref="add_application" />
        <viewModal :type="type" :my_title="my_title" ref="view_application" />
        <newHolding @pushHolding='pushHolding' ref="add_holding" />
        <editApplicationModal ref="edit_application"></editApplicationModal>
        <Citizen ref="add_citizen" />
    </div>
</template>

<script>
import axios from "axios"
import pagination from 'laravel-vue-pagination'
import viewModal from '@/views/application/market/view_application';
import addModal from '@/views/application/market/new_connection_add';
import newHolding from '@/views/application/market/new_holding';
import findUser from '@/views/application/others/find_user_modal';
import Citizen from '@/views/contact/AddContactModal';
import editApplicationModal from '@/views/application/market/editApplicationModal'
import { SEARCH_APPLICATION} from "@/store/action.type"
import { mapGetters } from "vuex"
export default {
    data(){
        return {
            loading:false,
            permission:'',

            search:{
                account_no:'',
                ward:''
            },
            user:{
                nid:'',
                mobile_number:''
            },
            my_title: 'মার্কেট লিজ',
            type: 'new-market-leadge',
            statuses:[],
            permissions:{},
            priority:JSON.parse(this.$user.permission.permission).priority,
        }
    },
    methods:{
        viewDetails(data,key){
            this.$refs.view_application.openModal(data,key,this.statuses)
        },
        editApplication(data,id){
            this.$refs.edit_application.openModal(data,id)
        },
        viewApproveDetails(data,key,own){
            //console.log(data)
            if(this.permissions.priority == 3 && own == this.permissions.priority && !data.confirm_2){
                this.$refs.view_application.openModal(data,key,this.statuses)
            }
            else if(this.permissions.priority == 2 && own == this.permissions.priority && !data.confirm_1){
                this.$refs.view_application.openModal(data,key,this.statuses)
            }
            else if(this.permissions.priority == 1 && own == this.permissions.priority){
                this.$refs.view_application.openModal(data,key,this.statuses)
            }
        },
        userInfo(data){
            this.$refs.add_application.openModal(data)
        },
        openCitizenModal(){
            if(this.$user.type == 2){
                var user = {
                    nid:this.$user.nid,
                    mobile_number:this.$user.mobile_number,
                    project_category_id:1
                }
                axios.post("/api/application-user",user).then(response=>{
                    this.userInfo(response.data)
                })
            }
            else{
                this.$refs.find_user.openModal()
            }
        },
        getResults(page = 1){
            var data = {type:'new-market-leadge', page:page}
            this.$store.dispatch('ALL_APPLICATION',data)
        },
        addHolding(user){
            // this.$refs.add_application.close()
            this.$refs.add_holding.openModal(user);
        },
        pushHolding(holding){
            this.$refs.add_application.pushHolding(holding)
        },
        async permissionSS(){
            await axios.post("/api/permissons/priority").then(response=>{
                this.statuses = response.data.role_name
                this.permissions = response.data.permisson[0]
                this.user_id = this.$user.id
            })
        },
        citizenAdd(){
            this.$refs.add_citizen.openModal();
        },
        searchApplication(){
            this.loading = true;
            var data = this.search
            //console.log(data)
            var page = 1
            this.$store.dispatch('SEARCH_APPLICATION',{page,data})
            .then(response=>{
                this.loading=false;
            })
            .catch(error=>{
                this.loading=false;
            });
        },
        allRole(){
            this.$store.dispatch('ALL_USER_ROLE')
        },
        getPermission(){
            this.$store.dispatch('ALL_USER_ROLE2')
            .then(response=>{
                this.permission = response.data.permission
            })
        }
    },

    mounted(){
        this.permissionSS()
        this.getResults()
        this.allRole()
        this.getPermission()

        var invoice_type = 'market-billing';
        this.$store.dispatch('WARD_LIST',{invoice_type})
        //console.log(this.getResults())
    },
    computed: {
        ...mapGetters(['wards',"allApplication","user_roles"]),
    },
    components:{
       findUser,
       addModal,
       viewModal,
       pagination,
       newHolding,
       Citizen,
       editApplicationModal
    }
}
</script>


<style>
.breadcrumb{
    margin-bottom: 1rem;
}
.main .container-fluid{
    padding: 0 16px;
}
 .actn{
     margin-left: 10px;
     cursor: pointer;
 }
 .contct{
     padding-bottom: 10px;
     padding-top: 10px
 }
 .contct-b{
     margin-bottom: 10px;
     margin-top: 10px
 }
 .load{
     margin-left: 50%;
 }
 .market_select{max-width: 200px;}
 @media (max-width: 575px){
    .contct-b{ width: 100% !important;}
    .market_select{ max-width: 100%; margin-bottom: 10px;}
    .contct{ padding-top: 0px;}
}
</style>
